module.exports = __webpack_public_path__ + "img/synovus-logo.9c938b24.jpg";